

























/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint vue/no-v-html: 0 */
import Vue from 'vue'
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'

import { RootState } from '@/store'

export default Vue.extend({
  name: 'AgreementPreContract',
  mixins: [validationMixin],
  validations: {
    confirm: {
      checked: value => value === true
    }
  },
  computed: {
    ...mapState({
      report: state => (state as RootState).agreement!.report.preContract
    }),
    confirm: { // setterが必要
      get: function () { return (this.$store.state as RootState).agreement!.confirm.preContract },
      set: () => { /* do nothing */ }
    },
    confirmError (): string {
      const confirm = this.$v.confirm!
      if (!confirm.$dirty) {
        return ''
      }
      return !confirm.checked ? '問題なければチェックをつけて下さい' : ''
    }
  },
  created (): void {
    this.$store.dispatch('agreement/getPreContract')
  },
  mounted (): void {
    // レポート取得済みの場合、スクロール制御しない
    if (this.report.contents || !window.MutationObserver) {
      return
    }
    const target = document.querySelector('.document-body')!
    const observer = new MutationObserver((mutation) => {
      if (mutation[0].addedNodes.length) {
        window.scrollTo(0, 0)
        observer.disconnect()
      }
    })
    observer.observe(target, { characterData: true, attributes: false, childList: false })
  },
  beforeRouteLeave (to, from, next) {
    // 規約等の同意画面から離れる時は、moduleの値をクリアする
    if ((to.name as string).indexOf('agreement') !== 0) {
      this.$store.commit('agreement/resetConfirm')
    }
    next()
  },
  methods: {
    /**
     * 契約締結前交付書面を閲覧しました
     */
    checkConfirm (value: boolean): void {
      this.$store.commit('agreement/confirm', { key: 'preContract', value })
    },
    goBack (): void {
      this.$router.push({ name: 'agreementContract' })
    },
    submit (): void {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.$router.push({ name: 'agreementOther' })
    }
  }
})
